export const LOCAL_STORAGE_KEYS = {
  DISMISSED_UPDATES: 'dismissedUpdates',
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  SHOW_LOG_CONVERSATION: 'showLogConversation',
  RESET_CONVERSATIONS: 'resetConversations',
};
